import enLang from './entries/en-US';
import ruLang from './entries/ru_RU';
import { addLocaleData } from 'react-intl';

const AppLocale = {
  ru: ruLang,
  en: enLang,
};
addLocaleData(AppLocale.ru.data);
addLocaleData(AppLocale.en.data);

export default AppLocale;
